module.exports = __webpack_public_path__ + "img/arrow-down-wide-short.8bb89d08.svg";